import react, { useState } from "react";
import styles from "./ResetPassword.module.css";
import { useParams } from "react-router-dom";
import { FloatLabel } from "primereact/floatlabel";
import DataLabLogo from "../../../assets/img/DataLabLogo.png";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { Password } from "primereact/password";
import { ChangePassword } from "../../../store/auth-store/auth-actions";
import { authActions } from "../../../store/auth-store/auth-slice";
import { InputText } from "primereact/inputtext";
import { validateToken } from "../../../utils/Guard";
import { uiActions } from "../../../store/ui-slice";

const ResetPassword = () => {
  const auth = useSelector((state) => state.auth.auth);
  const param = useParams();
  const dispatch = useDispatch();
  const [invalidField, setInvalidField] = useState("");
  const [filledInputs, setFilledInputs] = useState({
    password: false,
    repassword: false,
  });
  const [focused, setFocused] = useState({
    password: false,
    repassword: false,
  });

  const handleBlur = (field) => {
    setFocused((prev) => ({ ...prev, [field]: false }));
    setFilledInputs((prev) => ({ ...prev, [field]: prev[field] }));
  };

  const handleFocus = (field) => {
    setFocused((prev) => ({ ...prev, [field]: true }));
  };

  const onChangeHandler = (id, value) => {
    setFilledInputs((prev) => ({ ...prev, [id]: value.length > 0 }));
    dispatch(authActions.modifyPropertyValue({ id, value }));

    if (value !== "") {
      dispatch(authActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(authActions.setFieldValid({ id, value: false }));
    }
  };

  const onSubmitHandler = () => {
    setInvalidField("");

    if (auth.password === "") {
      setInvalidField("password");
      return;
    } else if (auth.password !== auth.repassword) {
      setInvalidField("repassword");
      return;
    }

    const userEmail = validateToken(param.token);

    if (userEmail) {
      const user = {
        email: userEmail,
        password: auth.repassword,
      };

      dispatch(ChangePassword(user));

      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    } else {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error al validar el token",
          message:
            "El token no es válido o ha expirado, por favor vuelva a solicitar el cambio de contraseña",
        })
      );
    }
  };

  return (
    <div
      className={`${styles.resetPasswordContainer} flex justify-content-center align-items-center`}
    >
      <div
        className={`${styles.resetPasswordCard} surface-card px-6 py-6 shadow-2 grid grid-nogutter`}
      >
        <div className={styles.resetPasswordFields}>
          <h2 className={`${styles.resetPasswordTitle} text-2xl`}>
            Cambiar contraseña
          </h2>
          <div className="flex flex-column gap-3">
            <FloatLabel
              className={
                filledInputs.password || focused.password ? "mt-4" : "mt-0"
              }
            >
              <InputText
                id="password"
                name="password"
                label="Contraseña"
                value={auth.password}
                onBlur={() => handleBlur("password")}
                onFocus={() => handleFocus("password")}
                onChange={(e) => onChangeHandler("password", e.target.value)}
                className={`${styles.InputFields} ${
                  invalidField === "password" ? "p-invalid" : ""
                }`}
                invalid={invalidField === "password"}
                feedback={false}
              />
              <label htmlFor="email" className={styles.InputFields}>
                Nueva contraseña
              </label>
            </FloatLabel>
            {invalidField === "password" && (
              <small id="name-help" className={`${styles.inputWarningText}`}>
                El campo contraseña no puede estar vacío
              </small>
            )}
            <FloatLabel
              className={
                filledInputs.repassword || focused.repassword ? "mt-4" : "mt-0"
              }
            >
              <InputText
                id="repassword"
                name="repassword"
                label="Repetir Contraseña"
                value={auth.repassword}
                onBlur={() => handleBlur("repassword")}
                onFocus={() => handleFocus("repassword")}
                onChange={(e) => onChangeHandler("repassword", e.target.value)}
                className={`${styles.InputFields} ${
                  invalidField === "repassword" ? "p-invalid" : ""
                }`}
                invalid={invalidField === "repassword"}
                feedback={false}
              />

              <label htmlFor="password" className={styles.InputFields}>
                Repetir contraseña
              </label>
            </FloatLabel>
            {invalidField === "repassword" && (
              <small id="name-help" className={`${styles.inputWarningText}`}>
                El campo repetir contraseña debe ser igual al campo nueva
                contraseña
              </small>
            )}

            <Button
              onClick={() => onSubmitHandler()}
              label="Cambiar contraseña"
              type="submit"
              className={`${styles.resetPasswordButton} p-button-primary`}
            />
          </div>
        </div>
      </div>
      <div className={styles.logoContainer}>
        <img
          src={DataLabLogo}
          alt="PrimeReact Logo"
          className={`${styles.logo} mb-4`}
        />
      </div>
    </div>
  );
};

export default ResetPassword;
